var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("van-icon", {
            staticClass: "header-return",
            attrs: { name: "arrow-left", size: "25", color: "#ffffff" },
            on: {
              click: function($event) {
                return _vm.onClickHeaderReturn()
              }
            }
          }),
          _vm._v("\n    Reset Password\n  ")
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _vm.step == 1
          ? _c(
              "div",
              { staticClass: "step" },
              [
                _c("img", {
                  attrs: { src: require("@/assets/icons/icon_email.png") }
                }),
                _c("div", { staticClass: "title" }, [_vm._v("Enter email")]),
                _c("div", { staticClass: "msg" }, [
                  _vm._v("Please enter your registered email address")
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.email,
                      expression: "email",
                      modifiers: { trim: true }
                    }
                  ],
                  ref: "email",
                  staticClass: "input-email",
                  attrs: {
                    type: "text",
                    placeholder: "Email address",
                    maxlength: "30"
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.email = $event.target.value.trim()
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _c(
                  "van-button",
                  {
                    staticClass: "button-confirm",
                    style: _vm.time > 0 ? "background:#A7A9AC;" : "",
                    attrs: {
                      type: "default",
                      disabled: _vm.time > 0 ? true : false
                    },
                    on: { click: _vm.onClickConfirm }
                  },
                  [
                    _vm._v("\n        Confirm\n        "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.time > 0,
                            expression: "time > 0"
                          }
                        ]
                      },
                      [_vm._v(" (" + _vm._s(_vm.time) + "s)")]
                    )
                  ]
                )
              ],
              1
            )
          : _vm.step == 2
          ? _c(
              "div",
              { staticClass: "step" },
              [
                _c("img", {
                  attrs: { src: require("@/assets/icons/icon_email2.png") }
                }),
                _c("div", { staticClass: "title" }, [
                  _vm._v("Verification code")
                ]),
                _c("div", { staticClass: "msg" }, [
                  _vm._v(
                    "\n        We have sent an email with a verification code to your mailbox. Please\n        enter the verification code you received. The verification code is\n        valid for 30 minutes.\n      "
                  )
                ]),
                _c("van-password-input", {
                  attrs: {
                    gutter: 10,
                    mask: false,
                    value: _vm.verificationCode,
                    focused: _vm.showKeyboard
                  },
                  on: {
                    focus: function($event) {
                      _vm.showKeyboard = true
                    }
                  }
                }),
                _c("van-number-keyboard", {
                  attrs: { show: _vm.showKeyboard },
                  on: {
                    blur: function($event) {
                      _vm.showKeyboard = false
                    }
                  },
                  model: {
                    value: _vm.verificationCode,
                    callback: function($$v) {
                      _vm.verificationCode = $$v
                    },
                    expression: "verificationCode"
                  }
                })
              ],
              1
            )
          : _vm.step == 3
          ? _c(
              "div",
              { staticClass: "step" },
              [
                _c("img", {
                  attrs: { src: require("@/assets/icons/icon_password.png") }
                }),
                _c("div", { staticClass: "title" }, [_vm._v("Reset password")]),
                _c("div", { staticClass: "msg" }, [
                  _vm._v(
                    "\n        Please reset your login password. After the setting is successful, the\n        original password will be invalid. Please use the new password to log\n        in to the APP\n      "
                  )
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.pwd,
                      expression: "pwd",
                      modifiers: { trim: true }
                    }
                  ],
                  ref: "new-pwd",
                  staticClass: "input-email",
                  attrs: {
                    type: "password",
                    placeholder: "New password",
                    maxlength: "30"
                  },
                  domProps: { value: _vm.pwd },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.pwd = $event.target.value.trim()
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.confirmPwd,
                      expression: "confirmPwd",
                      modifiers: { trim: true }
                    }
                  ],
                  ref: "confirm-pwd",
                  staticClass: "input-email",
                  attrs: {
                    type: "password",
                    placeholder: "Confirm password",
                    maxlength: "30"
                  },
                  domProps: { value: _vm.confirmPwd },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.confirmPwd = $event.target.value.trim()
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _c(
                  "van-button",
                  {
                    staticClass: "button-confirm",
                    attrs: { type: "default" },
                    on: { click: _vm.onClickReset }
                  },
                  [_vm._v("\n        Reset\n      ")]
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c(
        "van-popup",
        {
          staticClass: "tips-popup",
          style: { width: "88%" },
          attrs: { round: "" },
          model: {
            value: _vm.showTips,
            callback: function($$v) {
              _vm.showTips = $$v
            },
            expression: "showTips"
          }
        },
        [
          _c("div", { staticClass: "tips-header" }, [_vm._v("Tips")]),
          _c(
            "div",
            { staticClass: "tips-content" },
            [
              _c("div", { staticClass: "tips-content-msg" }, [
                _vm._v(_vm._s(_vm.tipsMsg))
              ]),
              _c(
                "van-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "tips-button",
                  attrs: { type: "default" },
                  on: { click: _vm.onClickTipsOK }
                },
                [_vm._v("\n        OK\n      ")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "van-popup",
        {
          staticClass: "success-popup",
          style: { width: "88%" },
          attrs: { round: "", "close-on-click-overlay": false },
          model: {
            value: _vm.showSuccessPopup,
            callback: function($$v) {
              _vm.showSuccessPopup = $$v
            },
            expression: "showSuccessPopup"
          }
        },
        [
          _c(
            "div",
            { staticClass: "success-content" },
            [
              _c("img", {
                attrs: { src: require("@/assets/icons/icon_success.png") }
              }),
              _c("div", { staticClass: "success-title" }, [
                _vm._v("Password has been reset")
              ]),
              _c("div", { staticClass: "success-msg" }, [
                _vm._v("Please log in with new password")
              ]),
              _c(
                "van-button",
                {
                  directives: [{ name: "waves", rawName: "v-waves" }],
                  staticClass: "success-button",
                  attrs: { type: "default" },
                  on: { click: _vm.onClickLogin }
                },
                [_vm._v("\n        Log in\n      ")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }